module.exports = __webpack_public_path__ + "img/icon-diagonal-up-arrow.2dd1d512.svg";